import Cookies from 'js-cookie'

import { PassengerNumbers } from '../../../common/types'
import { getNumOfPassengers } from '../../services/airSearch/airSearchRequest/helpers'
import { getPackageType } from '../../helpers/getPackageType'
import { translateSearchRequest } from '../../util/translateSearchRequest'

export const getPassengersCountHelper = (searchParams) => {
  const getAdultCount = getNumOfPassengers(searchParams[PassengerNumbers.ADULT])
  const getChildCount = getNumOfPassengers(searchParams[PassengerNumbers.CHILD])
  const getInfantCount = getNumOfPassengers(searchParams[PassengerNumbers.LAP_INFANT])
  return {
    ADULT: getAdultCount,
    CHILD: getChildCount,
    LAP_INFANT: getInfantCount,
  }
}
export const checkIfSinglePassenger = (searchParams) => {
  const searchDetails = getPassengersCountHelper(searchParams)
  return searchDetails.ADULT + searchDetails.CHILD + searchDetails.LAP_INFANT === 1
}

export const isNumOfAdultPassengers = (searchParams, isShelves) => {
  const searchDetails = getPassengersCountHelper(searchParams)
  return (
    (isShelves ? searchDetails.ADULT >= 1 : searchDetails.ADULT > 1) &&
    searchDetails.CHILD === 0 &&
    searchDetails.LAP_INFANT === 0
  )
}

// PackageListingHeaderPrice only turns a '0' price into copy for Hotel + Flight on slice 1.
// Anywhere else it renders a literal $0/person, so AHC and return slices keep the real price.
export const getIsAllProposalPricesMissing = ({
  hasPriorPackageSelection,
  isProposalPricingMissing,
  activeTabId,
  packageType,
}) =>
  hasPriorPackageSelection &&
  isProposalPricingMissing &&
  activeTabId === 1 &&
  (packageType === 'Hotel + Flight' || packageType === 'Flight + Hotel')

export const getPackageListingHeaderProps = ({
  listings,
  recommendedListings = [],
  activeTabId,
  packageType,
  searchRequest,
  searchSlices,
  hasPriorPackageSelection,
  isProposalPricingMissing,
}) => {
  const isRecommendedSearch = activeTabId === 1 && recommendedListings.length > 0
  const headerListings = isRecommendedSearch ? recommendedListings : listings
  const perPersonPrice =
    headerListings?.[0]?.fareBrands?.[0]?.price?.[0]?.packagesPriceData?.displayPerPersonCost
  const isAllProposalPricesMissing = getIsAllProposalPricesMissing({
    hasPriorPackageSelection,
    isProposalPricingMissing,
    activeTabId,
    packageType,
  })
  const destinationAirport = searchSlices?.[0]?.destinationAirport

  return {
    destination: searchRequest?.airports?.[destinationAirport]?.cityName,
    perPersonPrice: isAllProposalPricesMissing ? '0' : perPersonPrice,
    packageType,
    activeTabId,
    isRecommendedSearch,
  }
}

export const getBundleTypeString = (bundleComponents = [], isPackageListings = false) => {
  if (!isPackageListings || bundleComponents.length === 0) return ''

  let bundleType = ''
  const hotels = bundleComponents.filter((comp) => comp.type === 'STAY')

  if (hotels.length > 0) {
    hotels.forEach(() => {
      bundleType = bundleType + 'H'
    })
  }

  if (bundleComponents.find((comp) => comp.type === 'FLY')) {
    bundleType = bundleType + 'A'
  }

  if (bundleComponents.find((comp) => comp.type === 'DRIVE')) {
    bundleType = bundleType + 'C'
  }

  return bundleType
}

export const generatePhoneBookPackagesInput = async (pclnBootstrapData) => {
  const PACKAGES_PLACEMENT_ID = 'Flights_Listings'
  const {
    requestLocals,
    isMobile,
    searchRequest,
    partner,
    hasUSDestinationsOnly,
    bundleComponents,
    authUser,
  } = pclnBootstrapData
  const { webstats, referral, locale } = requestLocals
  const clientDevice = isMobile ? 'MOBILE' : 'DESKTOP'
  const clientIP = webstats?.resolvedClientIP
  const { params = {} } = searchRequest
  const cartKey = params['cart-key']
  const packageType = getPackageType(bundleComponents)
  const cguid = webstats?.clientGUID
  const translatedSearchRequest = translateSearchRequest(searchRequest)
  const { departingFrom, returningFrom, travelDate, returnDate } = translatedSearchRequest
  const airportsArray = Object.values(translatedSearchRequest?.airports || {})
  const originSource = departingFrom || airportsArray[0]
  const destinationSource = returningFrom || airportsArray[1]
  const origin = {
    airportCode: originSource?.airportCode,
    cityID: originSource?.cityId?.toString(),
    country: originSource?.countryName,
    countryCode: originSource?.countryCode,
    cityName: originSource?.cityName,
    stateCode: originSource?.stateCode,
    type: 'AIRPORT',
  }
  const destination = {
    airportCode: destinationSource?.airportCode,
    cityID: destinationSource?.cityId?.toString(),
    country: destinationSource?.countryName,
    countryCode: destinationSource?.countryCode,
    cityName: destinationSource?.cityName,
    stateCode: destinationSource?.stateCode,
    type: 'AIRPORT',
  }
  return {
    cartID: cartKey,
    cguid: cguid,
    clientDevice: clientDevice,
    placementID: PACKAGES_PLACEMENT_ID,
    clientIP: clientIP,
    pageURL: window.location.href,
    isSignedIn: Boolean(authUser),
    referral: {
      appCode: clientDevice,
      placementID: PACKAGES_PLACEMENT_ID,
      cguid: cguid,
      clientCountryCode: locale?.countryCode,
      clientIP: clientIP,
      clientDevice: clientDevice,
      clientLocale: locale?.localeCode,
      currencyCode: 'USD',
      globalPartnerCode: partner?.globalPartnerCode || 'PCLN',
      plfCode: partner?.plfCode || 'PCLN',
      referralClickID: referral?.clickId,
      referralSourceID: referral?.sourceId,
      referralID: referral?.id,
      refID: referral?.sourceId + referral?.id,
      requestID: webstats?.clientRequestId,
      userAgent: webstats?.userAgent,
      visitID: webstats?.visitId,
      forterToken: Cookies.get('forterToken'),
    },
    search: {
      packageSearchOptions: {
        adults: parseInt(params['num-adults'] || '0'),
        children: parseInt(params['num-children'] || '0'),
        travelStartDate: travelDate,
        travelEndDate: returnDate,
        origin: origin,
        destination: destination,
        packagePrice: null,
        packageType: packageType,
      },
      flightSearchOptions: {
        origin: origin,
        destination: destination,
        isInternational: !hasUSDestinationsOnly,
      },
    },
  }
}
